import module from './module';
import routes from './routeConfig';

import CartController from './controllers/CartController';
import InvitedPeopleListController from './controllers/InvitedPeopleListController';
import PopupBagDirectiveController from './directives/PopupBagDirective';

import OrderDetailsDirective from './directives/OrderDetailsDirective';
import CartGroupsService from './services/CartGroupsService';
import CartDirective from './directives/CartDirective';
import CartGroupsDirective from './directives/CartGroupsDirective';
import StoreAdminCartController from "./controllers/StoreAdminCartController";

module.controller('Cartonomy.Cart.CartController', CartController);
module.controller('Cartonomy.Cart.InvitedPeopleListController', InvitedPeopleListController);
module.controller(StoreAdminCartController.$controllerName, StoreAdminCartController);


module.directive('popupBag', [function () {
    return {
        scope: {
            hasGroupOrder: '='
        },
        template: require('./views/popupBagDirective.pug'),
        controller: PopupBagDirectiveController
    };
}]);


module.config([
    '$stateProvider',
    function ($stateProvider) {
        routes.forEach(route => {
            $stateProvider
                .state(route);
        });
    }
]);

export default module.name;



// WEBPACK FOOTER //
// ./src/modules/cart/index.js